import React from 'react';
import { icons } from '../utilits/icons';
import { Link } from 'react-router-dom'
import { menu } from '../utilits/constants';

function Aside(props) {

    return (
        <aside className=''>
            <div className="top">
                <Link className="logo">
                    <span>{icons.logo}</span> Motiv
                </Link>

                <ul>
                    {
                        menu.map((element, value) => {
                            return <li>
                                <Link to={element.slug}>{element.icons} {element.linkName}</Link>
                            </li>
                        })
                    }
                </ul>
            </div>

            <ul>
                <li>
                    <Link>{icons.setting} Settings</Link>
                </li>
                <li>
                    <Link>{icons.logout} Logout</Link>
                </li>
            </ul>
        </aside>
    );
}

export default Aside;